import type { Selector, State as S } from 'model/State';
import { OrderResult } from '../models/orders';
import { State } from 'model/State';

export const selectQuotesResponse: Selector<any> = (state: S) => state.mac.orders.quotes;

export const selectQuotes: Selector<OrderResult | null> = (state: S) =>
  state.mac.orders.quotes.ifSuccess((r) => r);

export const selectInvoicesResponse: Selector<any> = (state: S) => state.mac.orders.invoices;

export const selectInvoices: Selector<OrderResult | null> = (state: S) =>
  state.mac.orders.invoices.ifSuccess((r) => r);

export const selectIsPONumberUpdateModalOpened: Selector<boolean> = (state: S) =>
  state.mac.orders.isPONumberUpdateModalOpened;

export const selectOrderDetailsForPONumberUpdateModal: Selector<any> = (state: S) =>
  state.mac.orders.orderDetailsForPONumberUpdateModal;

export const selectCopiedCartUUIDForEditing: Selector<string | null> = (state: S) =>
  state.mac.orders.copiedCartForEditing.ifSuccess((r) => r)?.uuid;

export const selectVerificationHash = (orderId: number, state: State) =>
  state.mac.orders.verificationHash?.[orderId]?.ifSuccess((r) => r);

export const selectSingleOrderResponse = (orderId: number, state: State) =>
  state.mac.orders.singleOrder?.[orderId];

export const selectSingleOrder = (orderId: number, state: State) =>
  state.mac.orders.singleOrder?.[orderId]?.ifSuccess((r) => r);

export const selectClonedOrderResponse = (id: number, state: State) =>
  state.mac.orders.clonedOrder?.[id]?.ifSuccess((r) => r);

export const selectEditedCartOrderResponse = (state: State) =>
  state.mac.orders.editedCartOrder?.ifSuccess((r) => r);
